import { useLocation, useParams, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { RoomView } from './RoomView';

export function Room() {
  const { state } = useLocation();
  const { roomId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!state) navigate('/error?msg=acceso_invalido', { replace: true });
  }, [state, navigate]);

  if (!state) return null;

  return (
    <RoomView
      roomId={roomId}
      available={state.available}
      expiresAt={state.expiresAt && new Date(state.expiresAt)}
      isStatic={state.type === 'static'}
    />
  );
}
